import React from "react";
import GlassCard from "../ui/GlassCard";
import Icon from "../ui/Icon";
import { whyChooseUs } from "../../data/whyChooseUs";

/**
 * "Why Choose Us" content block (left column of the home split section).
 */
const WhyChooseUs = () => (
  <div>
    <h2 className="mb-6 font-headline-lg text-headline-lg uppercase text-primary">
      Why Choose Us
    </h2>
    <p className="mb-12 font-body-lg text-body-lg text-on-surface-variant">
      We are committed to delivering tailored logistics solutions that meet the
      unique needs of your business.
    </p>
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
      {whyChooseUs.map((item) => (
        <GlassCard key={item.title} className="p-6 text-center">
          <Icon
            name={item.icon}
            className="mb-4 text-4xl text-primary-container"
          />
          <h4 className="mb-2 font-headline-lg-mobile text-headline-lg-mobile text-on-surface">
            {item.title}
          </h4>
          <p className="font-body-md text-sm text-on-surface-variant">
            {item.description}
          </p>
        </GlassCard>
      ))}
    </div>
  </div>
);

export default WhyChooseUs;
